import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0612ffd6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0612ffd6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0612ffd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0612ffd6')) {
      api.createRecord('0612ffd6', component.options)
    } else {
      api.reload('0612ffd6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0612ffd6&scoped=true", function () {
      api.rerender('0612ffd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/index.vue"
export default component.exports